export default __webpack_public_path__ + "static/media/0011.6070f54d.jpg";